import { commonUtils } from 'utils'
import { IContextUser } from 'contexts/AuthContext'
import { IDetailsColumnProp, INtuReportColumnProp } from './Ntu.interface'
import { CellProps } from '@inovua/reactdatagrid-community/types'
import { generateBgColor } from '../WrittenBusiness/constants'

export const ntuReportDataSource = [
  {
    totalNTUsInNov: 750.0,
    ntusYtd: 750.0,
  },
]

export const ntuReportColumns = [
  {
    name: 'totalNTUsInNov',
    header: 'Total NTUs in Nov',
    defaultFlex: 1,
    type: 'number',
    render: ({ data }: INtuReportColumnProp) => (data.totalNTUsInNov ? `£${commonUtils.formatNumberWithCommas(data.totalNTUsInNov)}` : '-'),
  },
  {
    name: 'ntusYtd',
    header: 'NTUs YTD',
    defaultFlex: 1,
    type: 'number',
    render: ({ data }: INtuReportColumnProp) => (data.ntusYtd ? `£${commonUtils.formatNumberWithCommas(data.ntusYtd)}` : '-'),
  },
]

export const generateDetailsColumns = (currentUser: IContextUser) => {
  const columns = [
    {
      name: 'companyName',
      header: 'Company Name',
      defaultFlex: 1,
      type: 'text',
      hide: currentUser.role !== 'superAdmin',
      onRender: (cellProps: CellProps, { data }: IDetailsColumnProp) => {
        if (cellProps.style && typeof cellProps.style === 'object') {
          const bgColor = generateBgColor(data.status)
          ;(cellProps.style as React.CSSProperties).background = bgColor
        }
      },
    },
    {
      name: 'advisorName',
      header: 'Adviser Name',
      defaultFlex: 1,
      type: 'text',
      hide: currentUser.role !== 'superAdmin',
      onRender: (cellProps: CellProps, { data }: IDetailsColumnProp) => {
        if (cellProps.style && typeof cellProps.style === 'object') {
          const bgColor = generateBgColor(data.status)
          ;(cellProps.style as React.CSSProperties).background = bgColor
        }
      },
    },
    {
      name: 'clientName',
      header: 'Client name',
      defaultFlex: 1,
      type: 'text',
      onRender: (cellProps: CellProps, { data }: IDetailsColumnProp) => {
        if (cellProps.style && typeof cellProps.style === 'object') {
          const bgColor = generateBgColor(data.status)
          ;(cellProps.style as React.CSSProperties).background = bgColor
        }
      },
    },
    {
      name: 'dateOfApplication',
      header: 'Date of application',
      defaultFlex: 1,
      type: 'date',
      onRender: (cellProps: CellProps, { data }: IDetailsColumnProp) => {
        if (cellProps.style && typeof cellProps.style === 'object') {
          const bgColor = generateBgColor(data.status)
          ;(cellProps.style as React.CSSProperties).background = bgColor
        }
      },
      render: ({ data }: IDetailsColumnProp) => (data.dateOfApplication ? commonUtils.formatDate(data.dateOfApplication) : '-'),
    },
    {
      name: 'lenderProvider',
      header: 'LENDER/PROVIDER',
      defaultFlex: 1,
      type: 'text',
      onRender: (cellProps: CellProps, { data }: IDetailsColumnProp) => {
        if (cellProps.style && typeof cellProps.style === 'object') {
          const bgColor = generateBgColor(data.status)
          ;(cellProps.style as React.CSSProperties).background = bgColor
        }
      },
    },
    {
      name: 'feeType',
      header: 'FEE TYPE',
      defaultFlex: 1,
      type: 'text',
      onRender: (cellProps: CellProps, { data }: IDetailsColumnProp) => {
        if (cellProps.style && typeof cellProps.style === 'object') {
          const bgColor = generateBgColor(data.status)
          ;(cellProps.style as React.CSSProperties).background = bgColor
        }
      },
    },
    {
      name: 'amount',
      header: 'Amount',
      defaultFlex: 1,
      type: 'number',
      render: ({ data }: IDetailsColumnProp) => (data.amount ? `£${commonUtils.formatNumberWithCommas(data.amount)}` : '-'),
      onRender: (cellProps: CellProps, { data }: IDetailsColumnProp) => {
        if (cellProps.style && typeof cellProps.style === 'object') {
          const bgColor = generateBgColor(data.status)
          ;(cellProps.style as React.CSSProperties).background = bgColor
        }
      },
    },
    {
      name: 'ntuDate',
      header: 'NTU DATE',
      defaultFlex: 1,
      type: 'date',
      onRender: (cellProps: CellProps, { data }: IDetailsColumnProp) => {
        if (cellProps.style && typeof cellProps.style === 'object') {
          const bgColor = generateBgColor(data.status)
          ;(cellProps.style as React.CSSProperties).background = bgColor
        }
      },
      render: ({ data }: IDetailsColumnProp) => (data.ntuDate ? commonUtils.formatDate(data.ntuDate) : '-'),
    },
  ]

  return columns.filter((column) => !column?.hide)
}
